/* global Loader:true $:true */

import debug from "debug";

import {toCamelCase} from './strings';
const MODULE_NAME = 'app.core/lib/objects';
const log = debug(MODULE_NAME);


const ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
export function elementAttrtibutesToObject (element, filterFn = () => true, transformFn = (name) => toCamelCase(name)) {
	const output = {};
	const attrs = Array.from($(element).get(ZERO).attributes);

	if (!attrs) {
		return output;
	}

	log(`converting element attributes to object`, attrs);

	return attrs.reduce((result, attribute) => {
		if (filterFn(attribute)) {
			const name = transformFn(attribute.name);
			let value = attribute.value;

			if (value === 'false' || value === 'true') {
				value = Boolean(value);
			}
			result[name] = attribute.value;
		}

		return result;
	}, output);

}



// WEBPACK FOOTER //
// ./client/src/core/lib/objects.js